import jQuery from 'jquery';

/**
 * Add toggle functionality to the Expandable List widget.
 *
 * @export
 */
export default function() {
  const $ = jQuery;

  $(document)
    .on('click', '[data-sf-role=toggleLink]', function() {
      $(this).next().toggleClass('is-hidden');
    })
    .on('click', '[data-sf-role=expandAll],[data-sf-role=collapseAll]', function() {
      var $this = $(this);
      var $list = $this.closest('.mg-list');
      var $listItems = $list.find('.mg-list-content');

      if ($this.data('sf-role') === 'expandAll') {
        $listItems.removeClass('is-hidden');
      } else {
        $listItems.addClass('is-hidden');
      }
      $this.addClass('is-hidden').siblings().removeClass('is-hidden');
    });
}


// WEBPACK FOOTER //
// ./assets/src/js/components/list.js